

export class Tabs {

  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.current = parseInt(this.container.dataset.index, 10);
    this.nav     = this.container.querySelector('nav');
    this.nav.addEventListener('click', this);
  }

  switch(index) {
    this.container.dataset.index = index;
    this.nav.querySelector('li.active')?.classList.remove('active');
    this.nav.querySelector('li:nth-child(' + index + ')')?.classList.add('active');
  }

  handleEvent(e) {
    if (e.type !== "click") {
      return;
    }

    switch (e.target.tagName) {
      case "A":
        this.switch(e.target.dataset.index);
        e.preventDefault();
        e.stopPropagation();
        break;
    }
  }
}
